import { render, staticRenderFns } from "./UserCompetitionsProposed.vue?vue&type=template&id=e0059b82&scoped=true&"
import script from "./UserCompetitionsProposed.vue?vue&type=script&lang=js&"
export * from "./UserCompetitionsProposed.vue?vue&type=script&lang=js&"
import style0 from "./UserCompetitionsProposed.vue?vue&type=style&index=0&id=e0059b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0059b82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0059b82')) {
      api.createRecord('e0059b82', component.options)
    } else {
      api.reload('e0059b82', component.options)
    }
    module.hot.accept("./UserCompetitionsProposed.vue?vue&type=template&id=e0059b82&scoped=true&", function () {
      api.rerender('e0059b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserCompetitionsProposed.vue"
export default component.exports